import {
  AppBar,
  Box,
  Button,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import { useLocation, useNavigate } from "react-router-dom";
import hireSmartLogo from "../layout/hiresmart-logo.png";
interface NavbarProps {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
  pageTitle?: string;
}

const ROUTE_TITLES: Record<string, string> = {
  "/dashboard": "Dashboard",
  "/users": "Users",
  "/manage-job-descriptions": "Job Descriptions",
  "/hr-dashboard": "HR Workspace",
};

const getRouteTitle = (pathname: string) => {
  if (ROUTE_TITLES[pathname]) return ROUTE_TITLES[pathname];
  const route = Object.keys(ROUTE_TITLES).find(
    (item) => item !== "/" && pathname.startsWith(`${item}/`),
  );
  return route ? ROUTE_TITLES[route] : "HireSmart";
};

const Navbar = ({ sidebarOpen, toggleSidebar, pageTitle }: NavbarProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    navigate("/login");
  };

  return (
    <AppBar
      position="fixed"
      color="inherit"
      elevation={0}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        borderBottom: 1,
        borderColor: "divider",
        bgcolor: "rgba(255,255,255,.96)",
        backdropFilter: "blur(10px)",
      }}
    >
      <Toolbar sx={{ minHeight: 64, px: { xs: 1.5, sm: 2.5 } }}>
        <IconButton
          aria-label={sidebarOpen ? "Collapse navigation" : "Expand navigation"}
          aria-expanded={sidebarOpen}
          onClick={toggleSidebar}
          edge="start"
          sx={{ mr: 1.5, minWidth: 44, minHeight: 44 }}
        >
          <MenuIcon />
        </IconButton>

        <Box
          component="img"
          src={hireSmartLogo} 
          alt="HireSmart logo"
          sx={{
            width: { xs: 112, sm: 150 },
            height: 40,
            objectFit: "contain",
            objectPosition: "left center",
            flexShrink: 0,
            mr: 1.25,
          }}
        />

        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography
            component="h1"
            fontWeight={750}
            lineHeight={1.2}
            noWrap
            sx={{ pl: 1.5, borderLeft: "1px solid", borderColor: "divider" }}
          >
            {pageTitle || getRouteTitle(location.pathname)}
          </Typography>
        </Box>

        <Button
          onClick={handleLogout}
          color="inherit"
          startIcon={<LogoutIcon />}
          sx={{ minHeight: 44, color: "text.secondary", textTransform: "none" }}
        >
          <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
            Sign out
          </Box>
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;